export default "Snit en brummer af træ og skab magiske lyde fra fortiden! Denne aktivitet er svær/til voksne.";